<template>
  <div class="sidebar-items">
    <sidebar-item title="Home" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.3"
            d="M15.7817 6.32548L9.33366 0.506315C8.9669 0.18026 8.4921 0 8.00004 0C7.50799 0 7.03319 0.18026 6.66643 0.506315L0.218399 6.32548C0.0878088 6.44341 0.00956987 6.60799 0.000821009 6.78315C-0.00792785 6.95831 0.0535267 7.12978 0.171723 7.25999C0.234065 7.32865 0.310175 7.38358 0.395157 7.42125C0.480139 7.45892 0.572111 7.47849 0.66516 7.47871H1.33197V13.4437C1.33197 13.7952 1.47247 14.1324 1.72257 14.381C1.97268 14.6296 2.31189 14.7692 2.66558 14.7692H5.33281C5.50966 14.7692 5.67927 14.6994 5.80432 14.5751C5.92937 14.4508 5.99962 14.2822 5.99962 14.1065V10.1298C5.99962 9.95403 6.06987 9.78545 6.19492 9.66115C6.31998 9.53686 6.48958 9.46703 6.66643 9.46703H9.33366C9.51051 9.46703 9.68011 9.53686 9.80516 9.66115C9.93021 9.78545 10.0005 9.95403 10.0005 10.1298V14.1065C10.0005 14.2822 10.0707 14.4508 10.1958 14.5751C10.3208 14.6994 10.4904 14.7692 10.6673 14.7692H13.3345C13.6882 14.7692 14.0274 14.6296 14.2775 14.381C14.5276 14.1324 14.6681 13.7952 14.6681 13.4437V7.47871H15.3349C15.4694 7.47836 15.6006 7.43763 15.7113 7.36185C15.822 7.28608 15.9072 7.1788 15.9555 7.05409C16.0038 6.92939 16.013 6.79308 15.982 6.66306C15.951 6.53303 15.8812 6.41536 15.7817 6.32548Z"
            fill="white"
          />
        </svg>
      </template>
    </sidebar-item>
    <sidebar-item title="Locations" url="/locations">
      <template v-slot:icon>
        <svg
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.3"
            d="M0.534517 11.7333H6.41553L6.67201 8.39097H9.32174L9.57821 11.7333H15.4592C15.5478 11.7331 15.635 11.7112 15.7132 11.6695C15.7913 11.6279 15.8581 11.5678 15.9075 11.4945C15.957 11.4211 15.9877 11.3368 15.997 11.2489C16.0063 11.161 15.9938 11.0722 15.9607 10.9902L11.7346 0.560608C11.6631 0.393435 11.5438 0.251044 11.3915 0.151309C11.2392 0.0515739 11.0607 -0.00105948 10.8786 1.61632e-05H8.67482L8.83819 2.22772H7.14739L7.31075 1.61632e-05H5.11518C4.93114 0.000274782 4.75137 0.0553119 4.59887 0.158083C4.44638 0.260854 4.32809 0.406683 4.25916 0.576904L0.0329969 11.0065C0.00325229 11.0877 -0.006585 11.1747 0.00430786 11.2604C0.0152007 11.3461 0.046507 11.428 0.0956082 11.4991C0.144709 11.5703 0.210178 11.6287 0.286537 11.6694C0.362897 11.7102 0.447928 11.7321 0.534517 11.7333ZM7.04284 3.5689H8.9509L9.19431 6.73201H6.79943L7.04284 3.5689Z"
            fill="white"
          />
        </svg>
      </template>
      <!-- <template v-slot:children>
        <router-link to="#">Bookings</router-link>
        <router-link to="#">Packaging and Tagging</router-link>
      </template> -->
    </sidebar-item>
    <sidebar-item title="Fleets" url="/fleets">
      <template v-slot:icon>
        <svg
          width="16"
          height="11"
          viewBox="0 0 16 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.3"
            d="M15.9987 5.13199C15.9964 5.05535 15.9719 4.97992 15.9261 4.91565L13.463 1.43732C13.3819 1.3237 13.2451 1.25486 13.0991 1.25486H11.3333H9.77057H9.77C9.529 1.25486 9.33314 1.4392 9.33314 1.66656V8.37328C9.33314 8.59997 9.529 8.78431 9.77057 8.78431H10.6664H10.6667C10.6667 9.82391 11.5621 10.6667 12.6667 10.6667C13.7711 10.6667 14.6664 9.82391 14.6667 8.78431H15.5626C15.8037 8.78431 16 8.59997 16 8.37274V5.14382C15.9999 5.13992 15.999 5.13589 15.9987 5.13199ZM11.3333 5.01958V2.50959H13.0203L14.7981 5.01958H11.3333ZM12.6664 9.72549C12.1153 9.72549 11.6664 9.30317 11.6664 8.78431C11.6664 8.26545 12.1153 7.84313 12.6664 7.84313C13.2177 7.84313 13.6664 8.26545 13.6664 8.78431C13.6664 9.30317 13.2177 9.72549 12.6664 9.72549ZM8.08586 0H0.580571C0.259857 0 0 0.244573 0 0.546423V8.23775C0 8.53946 0.259857 8.78417 0.580429 8.78417H1.99971C1.99971 9.82377 2.89514 10.6665 3.99971 10.6665C5.10429 10.6665 5.99971 9.82377 5.99971 8.78417H8.08586C8.40643 8.78417 8.66629 8.53946 8.66629 8.23775V0.546288C8.66643 0.244573 8.40672 0 8.08586 0ZM3.99986 9.72549C3.44871 9.72549 2.99986 9.30317 2.99986 8.78431C2.99986 8.26545 3.44871 7.84313 3.99986 7.84313C4.55114 7.84313 4.99986 8.26545 4.99986 8.78431C4.99986 9.30317 4.55114 9.72549 3.99986 9.72549Z"
            fill="white"
          />
        </svg>
      </template>
      <!-- <template v-slot:children>
        <router-link to="#">Bookings</router-link>
        <router-link to="#">Packaging and Tagging</router-link>
      </template> -->
    </sidebar-item>
    <sidebar-item title="Users" url="/settings/users-and-groups">
      <template v-slot:icon>
        <svg
          width="16"
          height="19"
          viewBox="0 0 16 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M12.891 3.57728C12.891 5.13075 10.7012 4.74346 8.00009 4.74346C5.29899 4.74346 3.10913 5.13075 3.10913 3.57728C3.10913 2.02381 5.29899 0 8.00009 0C10.7012 0 12.891 2.024 12.891 3.57728Z"
              fill="white"
            />
            <path
              d="M2.95098 17.7563C2.95098 14.9719 5.21178 12.7141 8 12.7141C10.7882 12.7141 13.049 14.9719 13.049 17.7563C13.049 17.8422 13.0453 17.9273 13.0409 18.0123H16C15.9804 14.7875 14.2064 11.9974 11.6229 10.627C10.6605 11.4882 9.39072 12.013 7.99887 12.013C6.60815 12.013 5.33841 11.4882 4.37708 10.627C1.79396 11.998 0.0199454 14.7875 0 18.0123H2.95907C2.95475 17.9273 2.95098 17.8422 2.95098 17.7563Z"
              fill="white"
            />
            <path
              d="M6.5904 17.5795L4.22103 16.3242C4.05168 16.7699 3.95459 17.2512 3.95459 17.7561C3.95459 17.8425 3.96061 17.9273 3.96682 18.012H6.51908C6.52304 17.8617 6.54637 17.7161 6.5904 17.5795Z"
              fill="white"
            />
            <path
              d="M12.0455 17.7561C12.0455 17.251 11.9484 16.7699 11.779 16.3242L9.52368 17.519C9.58051 17.6734 9.61362 17.8392 9.61852 18.012H12.0334C12.0394 17.9273 12.0455 17.8424 12.0455 17.7561Z"
              fill="white"
            />
            <path
              d="M8.06791 16.5032C8.35148 16.5032 8.61622 16.5802 8.84484 16.7127L11.2934 15.4157C10.5598 14.3882 9.35947 13.7161 7.99999 13.7161C6.64031 13.7161 5.4402 14.3882 4.70654 15.4157L7.22757 16.7512C7.46993 16.5949 7.75801 16.5032 8.06791 16.5032Z"
              fill="white"
            />
            <path
              d="M7.99999 11.0262C10.4422 11.0262 12.4219 9.04914 12.4219 6.61023C12.4219 6.06021 12.3204 5.53387 12.1362 5.0483C11.5749 5.2116 10.9271 5.21197 10.4642 5.21197C10.1163 5.21197 9.74578 5.2022 9.35346 5.19224C8.91823 5.18078 8.46796 5.16913 7.99999 5.16913C7.53203 5.16913 7.08175 5.18078 6.64634 5.19224C6.25401 5.20239 5.88352 5.21197 5.53579 5.21197C4.98258 5.21197 4.36653 5.18961 3.86414 5.04736C3.67992 5.5333 3.57813 6.05983 3.57813 6.61004C3.57812 9.04895 5.5578 11.0262 7.99999 11.0262Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
      <!-- <template v-slot:children>
        <router-link to="#">Bookings</router-link>
        <router-link to="#">Packaging and Tagging</router-link>
      </template> -->
    </sidebar-item>
    <sidebar-item-dropdown title="CRM" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M6.25001 6.87128H0.250001C0.1 6.87128 0 6.77114 0 6.62094V6.47073C0 4.86855 1.3 3.54175 2.92501 3.54175H3.57501C5.17501 3.54175 6.50001 4.84352 6.50001 6.47073V6.62094C6.50001 6.77114 6.37501 6.87128 6.25001 6.87128Z"
              fill="white"
            />
            <path
              d="M11.325 1.51425C11.325 0.688127 11.975 0.012207 12.775 0.012207C13.575 0.012207 14.225 0.688127 14.225 1.51425C14.225 2.34038 13.575 3.0163 12.775 3.0163C11.95 3.0163 11.325 2.34038 11.325 1.51425Z"
              fill="white"
            />
            <path
              d="M3.99981 11.2023H2.29981C2.1498 11.2023 2.0498 11.0772 2.0498 10.952V8.12314C2.0498 7.97294 2.1498 7.8728 2.29981 7.8728C2.42481 7.8728 2.54981 7.97294 2.54981 8.12314V10.7017H3.99981L3.69981 10.4763C3.59981 10.4012 3.57481 10.226 3.64981 10.1259C3.74981 10.0257 3.89981 10.0007 3.99981 10.0758L4.84981 10.7517C4.89981 10.8018 4.94981 10.8769 4.94981 10.952C4.94981 11.0271 4.92481 11.1022 4.84981 11.1523L3.99981 11.8282C3.87481 11.9283 3.72481 11.9033 3.64981 11.7781C3.57481 11.678 3.57481 11.5027 3.69981 11.4276L3.99981 11.2023Z"
              fill="white"
            />
            <path
              d="M13.925 8.12314V10.952C13.925 11.0772 13.825 11.2023 13.675 11.2023H11.975L12.275 11.4276C12.375 11.5027 12.4 11.678 12.325 11.7781C12.225 11.9033 12.075 11.9033 11.975 11.8282L11.125 11.1523C11.05 11.1022 11 11.0271 11 10.952C11 10.8769 11.025 10.8018 11.1 10.7517L11.95 10.0758C12.05 9.97566 12.225 10.0007 12.3 10.1259C12.4 10.226 12.375 10.4012 12.25 10.4763L11.95 10.7017H13.4V8.12314C13.4 7.97294 13.525 7.8728 13.65 7.8728C13.825 7.8728 13.925 7.97294 13.925 8.12314Z"
              fill="white"
            />
            <path
              d="M1.80005 1.51425C1.80005 0.688127 2.45005 0.012207 3.25005 0.012207C4.05005 0.012207 4.67506 0.688127 4.67506 1.51425C4.67506 2.34038 4.02505 3.0163 3.25005 3.0163C2.47505 3.0163 1.80005 2.34038 1.80005 1.51425Z"
              fill="white"
            />
            <path
              d="M6.0498 8.7488C6.0498 7.67234 6.92481 6.79614 7.99981 6.79614C9.07481 6.79614 9.94981 7.67234 9.94981 8.7488C9.94981 9.82527 9.07481 10.7015 7.99981 10.7015C6.92481 10.7265 6.0498 9.8503 6.0498 8.7488Z"
              fill="white"
            />
            <path
              d="M12.5751 15.2084V15.7842C12.5751 15.9344 12.4501 16.0345 12.3251 16.0345H3.67505C3.52505 16.0345 3.42505 15.9344 3.42505 15.7842V15.2084C3.42505 13.2557 5.02505 11.6536 6.97506 11.6536H9.00006C10.9751 11.6536 12.5751 13.2557 12.5751 15.2084Z"
              fill="white"
            />
            <path
              d="M16 6.47073V6.62094C16 6.77114 15.875 6.87128 15.75 6.87128H9.75C9.625 6.87128 9.5 6.77114 9.5 6.62094V6.47073C9.5 4.86855 10.8 3.54175 12.425 3.54175H13.075C14.7 3.54175 16 4.86855 16 6.47073Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
      <!-- <template v-slot:children>
        <router-link to="#">Bookings</router-link>
        <router-link to="#">Packaging and Tagging</router-link>
      </template> -->
    </sidebar-item-dropdown>
    <sidebar-item-dropdown title="Operations" url="/">
      <template v-slot:icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.059 6.66078C12.2442 6.66078 12.4126 6.6776 12.5979 6.69441V3.1291C12.5979 2.00232 11.6716 1.07736 10.5432 1.07736H9.22949V0.572829C9.22949 0.270114 8.9937 0.034668 8.69054 0.034668C8.38738 0.034668 8.15159 0.270114 8.15159 0.572829V1.07736H4.44632V0.572829C4.44632 0.270114 4.21053 0.034668 3.90737 0.034668C3.60422 0.034668 3.36843 0.270114 3.36843 0.572829V1.07736H2.07158C0.926317 1.07736 0 2.00232 0 3.1291V10.1588C0 11.2856 0.926317 12.2106 2.05474 12.2106H7.05685C7.04001 12.0256 7.02317 11.8574 7.02317 11.6724C7.04001 8.91433 9.29685 6.66078 12.059 6.66078ZM1.0779 4.1886V3.14591C1.0779 2.60775 1.51579 2.15368 2.07158 2.15368H3.36843V2.6582C3.36843 2.96092 3.60422 3.19637 3.90737 3.19637C4.21053 3.19637 4.44632 2.96092 4.44632 2.6582V2.15368H8.15159V2.6582C8.15159 2.96092 8.38738 3.19637 8.69054 3.19637C8.9937 3.19637 9.22949 2.96092 9.22949 2.6582V2.15368H10.5432C11.0821 2.15368 11.52 2.59093 11.52 3.14591V4.1886H1.0779Z"
            fill="#EDF2EF"
          />
          <path
            d="M12.059 7.7373C9.88634 7.7373 8.11792 9.50315 8.11792 11.6726C8.11792 13.8421 9.88634 15.6079 12.059 15.6079C14.2316 15.6079 16 13.8421 16 11.6726C16 9.50315 14.2316 7.7373 12.059 7.7373ZM13.5411 12.2108H12.059C11.7558 12.2108 11.52 11.9753 11.52 11.6726V9.8395C11.52 9.53678 11.7558 9.30134 12.059 9.30134C12.3621 9.30134 12.5979 9.53678 12.5979 9.8395V11.1344H13.5411C13.8442 11.1344 14.08 11.3699 14.08 11.6726C14.08 11.9753 13.8442 12.2108 13.5411 12.2108Z"
            fill="#EDF2EF"
          />
        </svg>
      </template>
      <template v-slot:children>
        <router-link :to="{ name: 'BookingsHome' }">Bookings</router-link>
        <router-link to="#">Orders</router-link>
        <router-link to="#">Packaging and Tagging</router-link>
        <router-link to="#">Load Assignment & Consolidation</router-link>
        <router-link to="#">Waybill & Dispatch</router-link>
        <router-link to="#">Invoice</router-link>
        <router-link to="#">Accidents & Reroutes</router-link>
      </template>
    </sidebar-item-dropdown>
    <sidebar-item-dropdown class="mt-3" title="Payments" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M16 1.84974C16 1.35916 15.8055 0.888669 15.4593 0.541776C15.1131 0.194883 14.6435 0 14.1538 0H1.84615C1.35652 0 0.886947 0.194883 0.540726 0.541776C0.194505 0.888669 0 1.35916 0 1.84974V2.46632H16V1.84974Z"
              fill="white"
            />
            <path
              d="M0 9.24892C0 9.7395 0.194505 10.21 0.540726 10.5569C0.886947 10.9038 1.35652 11.0987 1.84615 11.0987H14.1538C14.6435 11.0987 15.1131 10.9038 15.4593 10.5569C15.8055 10.21 16 9.7395 16 9.24892V3.69971H0V9.24892ZM2.46154 6.16602H3.69231C3.85552 6.16602 4.01204 6.23099 4.12745 6.34662C4.24286 6.46225 4.30769 6.61908 4.30769 6.7826C4.30769 6.94613 4.24286 7.10296 4.12745 7.21859C4.01204 7.33422 3.85552 7.39918 3.69231 7.39918H2.46154C2.29833 7.39918 2.1418 7.33422 2.0264 7.21859C1.91099 7.10296 1.84615 6.94613 1.84615 6.7826C1.84615 6.61908 1.91099 6.46225 2.0264 6.34662C2.1418 6.23099 2.29833 6.16602 2.46154 6.16602ZM2.46154 8.01576H6.15385C6.31706 8.01576 6.47358 8.08072 6.58899 8.19635C6.7044 8.31199 6.76923 8.46882 6.76923 8.63234C6.76923 8.79587 6.7044 8.9527 6.58899 9.06833C6.47358 9.18396 6.31706 9.24892 6.15385 9.24892H2.46154C2.29833 9.24892 2.1418 9.18396 2.0264 9.06833C1.91099 8.9527 1.84615 8.79587 1.84615 8.63234C1.84615 8.46882 1.91099 8.31199 2.0264 8.19635C2.1418 8.08072 2.29833 8.01576 2.46154 8.01576Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
      <!-- <template v-slot:children>
        <router-link to="#">Bookings</router-link>
        <router-link to="#">Packaging and Tagging</router-link>
      </template> -->
    </sidebar-item-dropdown>
    <sidebar-item title="Analytics" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M2 1H1V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H15V14H2V1Z"
              fill="white"
            />
            <path
              d="M15 4.5H11.5V5.5H13.295L9.5 9.295L7.355 7.145C7.30852 7.09814 7.25322 7.06094 7.19229 7.03555C7.13136 7.01017 7.06601 6.9971 7 6.9971C6.93399 6.9971 6.86864 7.01017 6.80771 7.03555C6.74678 7.06094 6.69148 7.09814 6.645 7.145L3 10.795L3.705 11.5L7 8.205L9.145 10.355C9.19148 10.4019 9.24678 10.4391 9.30771 10.4644C9.36864 10.4898 9.43399 10.5029 9.5 10.5029C9.56601 10.5029 9.63136 10.4898 9.69229 10.4644C9.75322 10.4391 9.80852 10.4019 9.855 10.355L14 6.205V8H15V4.5Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
    </sidebar-item>
    <sidebar-item title="Referrals" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7 14C7 14 6 14 6 13C6 12 7 9 11 9C15 9 16 12 16 13C16 14 15 14 15 14H7ZM11 8C11.7956 8 12.5587 7.68393 13.1213 7.12132C13.6839 6.55871 14 5.79565 14 5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8ZM5.216 14C5.06776 13.6878 4.99382 13.3455 5 13C5 11.645 5.68 10.25 6.936 9.28C6.30909 9.08684 5.65595 8.99237 5 9C1 9 0 12 0 13C0 14 1 14 1 14H5.216ZM4.5 8C5.16304 8 5.79893 7.73661 6.26777 7.26777C6.73661 6.79893 7 6.16304 7 5.5C7 4.83696 6.73661 4.20107 6.26777 3.73223C5.79893 3.26339 5.16304 3 4.5 3C3.83696 3 3.20107 3.26339 2.73223 3.73223C2.26339 4.20107 2 4.83696 2 5.5C2 6.16304 2.26339 6.79893 2.73223 7.26777C3.20107 7.73661 3.83696 8 4.5 8Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
    </sidebar-item>
    <sidebar-item title="Support" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M7.99992 1.33325C4.32392 1.33325 1.33325 4.32392 1.33325 7.99992V10.7619C1.33325 11.4446 1.93125 11.9999 2.66659 11.9999H3.33325C3.51006 11.9999 3.67963 11.9297 3.80466 11.8047C3.92968 11.6796 3.99992 11.5101 3.99992 11.3333V7.90459C3.99992 7.72777 3.92968 7.55821 3.80466 7.43318C3.67963 7.30816 3.51006 7.23792 3.33325 7.23792H2.72792C3.09859 4.65792 5.31859 2.66659 7.99992 2.66659C10.6813 2.66659 12.9013 4.65792 13.2719 7.23792H12.6666C12.4898 7.23792 12.3202 7.30816 12.1952 7.43318C12.0702 7.55821 11.9999 7.72777 11.9999 7.90459V11.9999C11.9999 12.7353 11.4019 13.3333 10.6666 13.3333H9.33325V12.6666H6.66659V14.6666H10.6666C12.1373 14.6666 13.3333 13.4706 13.3333 11.9999C14.0686 11.9999 14.6666 11.4446 14.6666 10.7619V7.99992C14.6666 4.32392 11.6759 1.33325 7.99992 1.33325Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
    </sidebar-item>
    <sidebar-item title="Feedback" url="/#">
      <template v-slot:icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M2.47614 9.71426V11.2381C2.48224 12.3093 2.98814 12.1428 3.363 11.8213L5.52376 9.87045V10.8571C5.52376 11.7828 5.7371 12 6.66662 12H10.0952C10.0952 12 12.0796 14.3333 12.0952 14.3177C12.3809 14.6666 13.1546 14.5478 13.1428 13.9047V12H14.2857C15.219 12 15.4285 11.768 15.4285 10.8571V5.14283C15.4285 4.22855 15.2038 3.99998 14.2857 3.99998H10.4761V3.23807C10.4761 2.29712 10.3009 2.09521 9.33329 2.09521H1.33329C0.434239 2.09521 0.19043 2.2895 0.19043 3.23807V8.19045C0.19043 9.1196 0.399953 9.71426 1.33329 9.71426H2.47614ZM12 10.8571V12.6556L10.4761 10.8571H7.04757C6.76186 10.8571 6.66662 10.7543 6.66662 10.4762V5.52379C6.66662 5.26855 6.78472 5.14283 7.04757 5.14283H13.9047C14.1672 5.14283 14.2857 5.28379 14.2857 5.50093V10.4762C14.2857 10.7508 14.1489 10.8571 13.9047 10.8571H12Z"
              fill="white"
            />
          </g>
        </svg>
      </template>
    </sidebar-item>

    <!-- <div class="sidebar-item curosor-pointer logout" @click="logout">
      <div class="sidebar-item__icon-container">
        <span class="sidebar-item__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:svgjs="http://svgjs.com/svgjs"
            version="1.1"
            width="16"
            height="16"
            x="0"
            y="0"
            viewBox="0 0 512 512"
            style="enable-background: new 0 0 512 512"
            xml:space="preserve"
          >
            <g>
              <g xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15    c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724    c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262    C276.412,478.129,266.908,468.625,255.15,468.625z"
                    fill="#ffffff"
                    data-original="#000000"
                    style=""
                  />
                </g>
              </g>
              <g xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173    H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173    c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575    c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z"
                    fill="#ffffff"
                    data-original="#000000"
                    style=""
                  />
                </g>
              </g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
            </g>
          </svg>
        </span>
      </div>
      <div class="sidebar-item__title">
        <p>Logout</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import SidebarItem from "./partials/SidebarItem";
import SidebarItemDropdown from "./partials/SidebarItemDropdown";
export default {
  components: {
    SidebarItem,
    SidebarItemDropdown,
  },
  data() {
    return {
      showTerminalChildren: false,
    };
  },
  methods: {
    async logout() {
      try {
        // await this.$_logout();
        localStorage.clear();
        // localStorage.clear();
        this.$router.push({ name: "Login" });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.router-link-active {
  background: #9bbbe2;
  border-left: 5px solid #f57a4d;
  padding-left: 2.5rem !important;
}
.sidebar-item {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0.6rem 1rem;
}
.sidebar-item__icon-container {
  display: flex;
  height: 100%;
  align-items: center;
}
.sidebar-item__icon {
  margin-right: 1rem;
}
.logout {
  cursor: pointer;
  svg {
    opacity: 0.3;
  }
  p {
    opacity: 0.6;
  }
}
</style>
